import { useMemo, useCallback, useContext } from 'react'
import MultiSelect, { MultiSelectOption } from 'components/shared/MultiSelect'
import { IEventData } from 'interface/calendar'
import { RenderParticipant } from './RenderParticipant'
import { CalendarStateContext } from 'context/CalendarContext'

interface IEventGuestSelectProps {
  eventData: IEventData
  setEventData: React.Dispatch<React.SetStateAction<IEventData>>
}

export const EventGuestSelect: React.FC<IEventGuestSelectProps> = ({
  eventData,
  setEventData,
}) => {
  const { officeEmployees } = useContext(CalendarStateContext)

  const guestOptions = useMemo(() => {
    if (!officeEmployees) {
      return []
    }
    return officeEmployees.map((employee) => ({
      label: employee.name,
      value: employee.id,
    }))
  }, [officeEmployees])

  const renderMultiSelectOptionImage = useCallback(
    (option: MultiSelectOption) => {
      const employee = officeEmployees?.find(
        (employee) => employee.id === option.value
      )
      return employee ? <RenderParticipant participant={employee} /> : null
    },
    [officeEmployees]
  )

  return (
    <div>
      <p className="font-inter text-[14px] font-normal leading-4 text-dark-gray-100 mb-1">
        Guests
      </p>
      <MultiSelect
        icon="search"
        placeholder="Add guests"
        maxVisibleOptions={3}
        options={guestOptions}
        value={eventData.participants.map((participant) => ({
          value: participant.id,
          label: participant.name,
        }))}
        onChange={(value) => {
          const ids = value.map((item) => item.value)
          const employees = officeEmployees.filter((employee) =>
            ids.includes(employee.id)
          )
          setEventData((prevData) => ({
            ...prevData,
            participants: employees,
          }))
        }}
        renderImage={renderMultiSelectOptionImage}
      />
    </div>
  )
}
